import * as React from 'react';
import { connect } from 'react-redux';
import { CreateSurveyProps } from '../../../common/CreateSurveyProps';
import { ApplicationState } from '../../../store';
import * as CreateSurveyStore from '../../../store/CreateSurvey';
import produce from 'immer';
import {arrayMove, SortableContainer, SortableElement} from 'react-sortable-hoc';

import { validateString } from '../../../common/helperFunctions';
import { MatrixRowColumnModel } from '../../../models/mcq-option.model';

export interface iState {
    validationChecked: boolean,
    generalErrorMessage: string,

    matrixRowIndex: number,
    matrixRowArray: MatrixRowColumnModel[],
    
    matrixColumnIndex: number,
    matrixColumnArray: MatrixRowColumnModel[],
    
    rowEnglishText: string,
    rowFrenchText: string,

    columnEnglishText: string,
    columnFrenchText: string,

    items: string[]
}

class Matrix extends React.Component<CreateSurveyProps, iState> {
    private mcqEnglishInput: React.RefObject<HTMLTextAreaElement>;
    
    rowTemp: MatrixRowColumnModel[] = [];
    columnTemp: MatrixRowColumnModel[] = [];
    state = {
        validationChecked: false,
        generalErrorMessage: '',
        
        matrixRowIndex: -1,
        matrixRowArray: this.rowTemp,
        
        matrixColumnIndex: -1,
        matrixColumnArray: this.columnTemp,

        rowEnglishText: '',
        rowFrenchText: '',
    
        columnEnglishText: '',
        columnFrenchText: '',

        items: ['Item 1', 'Item 2', 'Item 3', 'Item 4', 'Item 5', 'Item 6']
    }

    constructor(props: any) {
        super(props);
           
        this.mcqEnglishInput = React.createRef();
    }

    public componentDidMount() {

        this.setState(
            produce(this.state, draftState => {
                
                if (this.props.editQuestion.matrixRows)
                    draftState.matrixRowArray = [...this.props.editQuestion.matrixRows];
                
                if (this.props.editQuestion.matrixColumns)
                    draftState.matrixColumnArray = [...this.props.editQuestion.matrixColumns];

                const row = new MatrixRowColumnModel();
                draftState.matrixRowArray.push(row);

                const col = new MatrixRowColumnModel();
                draftState.matrixColumnArray.push(col);
            })
        );
    }

    handleMatrixRowTextChange = (e: React.ChangeEvent<HTMLInputElement>, index: number, language: string) => {
        e.target.value = e.target.value;

        let state =
            produce(this.state, draftState => {

                if (language === 'Fr') {
                    draftState.matrixRowArray[index].textFr = e.target.value;
                } else {
                    draftState.matrixRowArray[index].textEn = e.target.value;
                }

                draftState.matrixRowArray = draftState.matrixRowArray.filter((item, ix) => (
                    
                    ((validateString(true, item.textEn, 1, -1) ||
                    validateString(true, item.textFr, 1, -1)) ||
                     ix + 1 === draftState.matrixRowArray.length)
                ));

                if (!(
                    validateString(true, draftState.matrixRowArray[draftState.matrixRowArray.length-1].textEn, 1, -1) === false &&
                    validateString(true, draftState.matrixRowArray[draftState.matrixRowArray.length-1].textFr, 1, -1) === false)) {
                        draftState.matrixRowArray.push( new MatrixRowColumnModel());
                    }
            });

        this.setState( state , this.UpdateMatrixOption );
    };

    handleMatrixColumnTextChange = (e: React.ChangeEvent<HTMLInputElement>, index: number, language: string) => {
        e.target.value = e.target.value;

        let state =
            produce(this.state, draftState => {

                if (language === 'Fr') {
                    draftState.matrixColumnArray[index].textFr = e.target.value;
                } else {
                    draftState.matrixColumnArray[index].textEn = e.target.value;
                }

                draftState.matrixColumnArray = draftState.matrixColumnArray.filter((item, ix) => (
                    
                    ((validateString(true, item.textEn, 1, -1) ||
                    validateString(true, item.textFr, 1, -1)) ||
                     ix + 1 === draftState.matrixColumnArray.length)

                ));

                if (!(
                    validateString(true, draftState.matrixColumnArray[draftState.matrixColumnArray.length-1].textEn, 1, -1) === false &&
                    validateString(true, draftState.matrixColumnArray[draftState.matrixColumnArray.length-1].textFr, 1, -1) === false
                    )) {
                        draftState.matrixColumnArray.push( new MatrixRowColumnModel());
                    }

            })

        this.setState( state, this.UpdateMatrixOption );
    };

    private onColumnSortEnd = ({oldIndex, newIndex}: {oldIndex: number, newIndex: number}) => {
        if (oldIndex + 1 === this.state.matrixColumnArray.length || 
            newIndex + 1 === this.state.matrixColumnArray.length)
            return;

        let matrixColumnArray = produce(arrayMove(this.state.matrixColumnArray, oldIndex, newIndex), ds => {
            ds.forEach((e,  i) => {
                ds[i].sequence = i;
            });
        });


        this.setState( { matrixColumnArray: matrixColumnArray }, this.UpdateMatrixOption );
      };

    private onRowSortEnd = ({oldIndex, newIndex}: {oldIndex: number, newIndex: number}) => {
        if (oldIndex + 1 === this.state.matrixRowArray.length || 
            newIndex + 1 === this.state.matrixRowArray.length)
            return;

        let matrixRowArray = produce(arrayMove(this.state.matrixRowArray, oldIndex, newIndex), ds => {
            ds.forEach((e,i) => {
                ds[i].sequence = i;
            });
        });

        this.setState( { matrixRowArray: matrixRowArray }, this.UpdateMatrixOption );
    }

    UpdateMatrixOption() {

        let mr = produce(this.state.matrixRowArray, ds => {
            ds.pop();
        });

        let mc = produce(this.state.matrixColumnArray, ds => {
            ds.pop();
        });

        this.props.UpdateMatrixOption(mr, mc);
    }

    render() {
        return(
            <React.Fragment>
                {
                    this.RenderRatingScale()
                }
            </React.Fragment>
        );
    }
    

    RenderRatingScale() {
        return (
            <>
                <div className="row g-3 mb-2">
                    <div className='col-sm-6'>
                        <label className="form-label fw-bold">Questions:</label>
                        <SortableList lockAxis="y" disabled={this.props.survey.statusId === this.props.surveyStatusPublishedId} title="question" key='row' items={this.state.matrixRowArray} fun={this.handleMatrixRowTextChange} onSortEnd={this.onRowSortEnd} />
                    </div>
                    <div className='col-sm-6'>
                        <label className="form-label fw-bold">Choices:</label>
                        <SortableList lockAxis="y" disabled={this.props.survey.statusId === this.props.surveyStatusPublishedId} title="choice" key='column' items={this.state.matrixColumnArray} fun={this.handleMatrixColumnTextChange} onSortEnd={this.onColumnSortEnd} />
                    </div>
                </div>
            </>
        );
    }
};

const SortableItem = SortableElement((
    {title, value, fun, idx, arrayLength, disabled}:
        {title: string, value: MatrixRowColumnModel,
            fun: any, idx: number, arrayLength: number, disabled: boolean}) => (
    <div className="row mb-3">
        <div className='col-xs-12'>
            <div className="input-group">
                <span className="input-group-text text-muted">::</span>
                <input
                    value={ value.textEn }
                    className="form-control"
                    disabled={disabled}
                    placeholder={
                        (arrayLength === idx + 1)
                        ? `New ${title} - English`
                        : "English"
                    }
                    onChange={(e) => fun(e, idx, "En")}
                    required>
                </input>
            </div>
        </div>

        <div className='col-xs-12'>
            <div className="input-group">
                <span className="input-group-text text-muted">::</span>
                <input
                    value={ value.textFr }
                    className="form-control"
                    disabled={disabled}
                    placeholder={
                        (arrayLength === idx + 1)
                        ? `New ${title} - French`
                        : "French"
                    }
                    onChange={(e) => fun(e, idx, "Fr")}
                    required>
                </input>
            </div>
        </div>
    </div>
  ));
  
  const SortableList = SortableContainer(({title, key, items, fun, disabled}: {
                                        title: string, key: string, items: MatrixRowColumnModel[], 
                                        fun: any, disabled: boolean}) => {
    return (
      <div className='col-xs-12'>
        {
            items.map((value, index, array) => (
                <SortableItem key={`${key}-${index}`}
                index={index}
                title={title}
                value={value}
                fun={fun}
                idx={index}
                arrayLength={array.length}
                disabled={disabled}
                />
            ))
        }
      </div>
    );
  });

export default connect(
    (state: ApplicationState) => state.createSurveyStore,
    CreateSurveyStore.actionCreators
)(Matrix as any);
